import { useNavigate } from 'react-router';
import { useSuspenseOIDCProviderQuery } from '#api/oidc-providers.queries.ts';
import { Link } from '#components/atoms/link/Link.tsx';
import { MainLayout } from '#components/patterns/layouts/main/MainLayout.tsx';
import { PageHeader } from '#components/patterns/page-header/PageHeader.tsx';
import { useAppLocation } from '#hooks/useAppLocation.ts';
import { IdentityProviderFormWrapper } from '../../components/form/IdentityProviderFormWrapper.tsx';

type Props = {
  oidcProviderId: string;
};

export function EditAdminProvider({ oidcProviderId }: Props) {
  const navigate = useNavigate();
  const location = useAppLocation();
  const {
    data: { data: oidcProvider },
  } = useSuspenseOIDCProviderQuery(oidcProviderId);

  return (
    <MainLayout
      header={
        <PageHeader
          title={
            <>
              <Link to="/settings/sso" className="a">
                Single sign-on
              </Link>
              {' / '}
              {/* TODO: what should we use here?  Normally it's the name of the thing being edited */}
              <span>Admin identity provider</span>
            </>
          }
        />
      }
    >
      <IdentityProviderFormWrapper
        id={oidcProviderId}
        onClose={() => {
          void navigate(location.state?.from ?? '/settings/sso');
        }}
        adminIdentityProvider={oidcProvider}
        endpointIdentityProvider={null}
      />
    </MainLayout>
  );
}
